import PropTypes from 'prop-types'

import SurveyDesignSlider from '@aytm/app/stats/page/data-quality-report/sections/SurveyDesignSlider'
import style from '@aytm/app/stats/page/data-quality-report/styles/sections/SurveyDesign.module.scss'

const MAX_SCORE = 500

// Status dot color by impact level.
const DOT_CLASS = { good: 'dotGood', fair: 'dotFair', needs_work: 'dotNeedsWork' }

const ParamRow = ({ param }) => (
  <div data-testid="stat-dqr-survey-design-param" className={style.row}>
    <div className={style.cellMain}>
      <div data-testid="stat-dqr-survey-design-param-name" className={style.paramName}>
        {param.name}
      </div>
      {param.description ? <div className={style.paramDesc}>{param.description}</div> : null}
      <div data-testid="stat-dqr-survey-design-param-status" className={style.paramStatus}>
        <span className={[style.dot, style[DOT_CLASS[param.level]]].filter(Boolean).join(' ')} />
        {param.status}
      </div>
    </div>
    <div data-testid="stat-dqr-survey-design-param-actual" className={style.cellNum}>
      {param.yourSurvey}
    </div>
    <div data-testid="stat-dqr-survey-design-param-recommended" className={style.cellNum}>
      {param.recommended}
    </div>
  </div>
)

ParamRow.propTypes = { param: PropTypes.object.isRequired }

const SurveyDesign = ({ data }) => {
  const { score, parameters = [] } = data

  return (
    <div data-testid="stat-dqr-survey-design" className={style.design}>
      <SurveyDesignSlider score={score} max={MAX_SCORE} />

      <div className={style.params}>
        <div className={style.head}>
          <span className={style.colMain}>Parameters</span>
          <span className={style.colNum}>Your survey</span>
          <span className={style.colNum}>Recommended</span>
        </div>
        {parameters.map(param => (
          <ParamRow key={param.name} param={param} />
        ))}
        <div className={style.footer}>
          Read our article{' '}
          <a href="#" target="_blank" rel="noopener noreferrer">
            7 common Mistakes While Creating a Survey
          </a>{' '}
          for more insights
        </div>
      </div>
    </div>
  )
}

SurveyDesign.displayName = 'SurveyDesign'
SurveyDesign.propTypes = { state: PropTypes.string, tier: PropTypes.string, data: PropTypes.object }
SurveyDesign.defaultProps = { data: {} }
export default SurveyDesign
